import React from "react";
import { SearchX } from "lucide-react";
import EmptyState from "./EmptyState";
import { useTranslation } from "react-i18next";

const FilterNoResults = ({
  title,
  message,
  clearLabel,
  onClear,
  iconSize = 48,
}) => {
  const { t } = useTranslation();
  return (
    <EmptyState
      icon={SearchX}
      iconSize={iconSize}
      title={title ?? t("filterNoResults.title")}
      message={message ?? t("filterNoResults.message")}
      actionLabel={clearLabel ?? t("filterNoResults.clearLabel")}
      onAction={onClear}
    />
  );
};

export default FilterNoResults;
